const COUNTRY_CODES = [
    {
        code: "IL",
        label: "+972",
        name: "Israel",
        flag: "🇮🇱",
        normalizer: (number) => {
            if (number.startsWith("0")) {
                return number.substring(1)
            }
            return number;
        },
        validator: (number) => {
            const regex = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/;
            return regex.test(number);
        },
        enabledByDefault: true
    },
    {
        code: "US",
        label: "+1",
        name: "United States",
        flag: "🇺🇸",
        normalizer: (number) => {
            // Remove any non-digit characters except the leading +
            return number.replace(/[^\d]/g, '');
        },
        validator: (number) => {
            const regex = /^(\+?1)?[2-9]\d{2}[2-9]\d{2}\d{4}$/;
            return regex.test(number);
        }
    },
    {
        code: "GB",
        label: "+44",
        name: "United Kingdom",
        flag: "🇬🇧",
        normalizer: (number) => {
            if (number.startsWith("0")) {
                return number.substring(1)
            }
            return number;
        },
        validator: (number) => {
            const regex = /^(\+?44|0)[1-9]\d{8,9}$/;
            return regex.test(number);
        }
    },
    {
        code: "DE",
        label: "+49",
        name: "Germany",
        flag: "🇩🇪",
        normalizer: (number) => {
            if (number.startsWith("0")) {
                return number.substring(1)
            }
            return number;
        },
        validator: (number) => {
            const regex = /^(\+?49|0)[1-9]\d{4,14}$/;
            return regex.test(number);
        }
    },
    {
        code: "FR",
        label: "+33",
        name: "France",
        flag: "🇫🇷",
        normalizer: (number) => {
            if (number.startsWith("0")) {
                return number.substring(1)
            }
            return number;
        },
        validator: (number) => {
            const regex = /^(\+?33|0)[1-9]\d{8}$/;
            return regex.test(number);
        }
    }
];

const ENABLED_BY_DEFAULT_COUNTRIES = COUNTRY_CODES.filter(country => country.enabledByDefault);

export const getEnabledCountryCodes = (enabledCodes) => {
    if (!enabledCodes || enabledCodes.length === 0) {
        if (!ENABLED_BY_DEFAULT_COUNTRIES || ENABLED_BY_DEFAULT_COUNTRIES.length === 0) {
            throw new Error("No countries are enabled by default. Please configure enabledCountryCodes.");
        }
        return ENABLED_BY_DEFAULT_COUNTRIES;
    }

    const finalCodes = COUNTRY_CODES
        .filter(country => enabledCodes.includes(country.code));

    if (finalCodes.length === 0) {
        if (!ENABLED_BY_DEFAULT_COUNTRIES || ENABLED_BY_DEFAULT_COUNTRIES.length === 0) {
            throw new Error("No countries are enabled by default. Please configure enabledCountryCodes.");
        }
        return ENABLED_BY_DEFAULT_COUNTRIES;
    }
    return finalCodes;
};

export default getEnabledCountryCodes;
